import { readonly, ref } from 'vue';

export type ToastKind = 'error' | 'success';

export interface Toast {
  id: number;
  kind: ToastKind;
  message: string;
}

// Module-level queue so any component shares the same stack of toasts; the
// single <Toaster> mounted in App.vue renders it.
const toasts = ref<Toast[]>([]);
let nextId = 0;
const DEFAULT_DURATION_MS = 5000;

function dismiss(id: number): void {
  const idx = toasts.value.findIndex((t) => t.id === id);
  if (idx !== -1) toasts.value.splice(idx, 1);
}

function push(kind: ToastKind, message: string, durationMs = DEFAULT_DURATION_MS): number {
  const id = ++nextId;
  toasts.value.push({ id, kind, message });
  if (durationMs > 0) window.setTimeout(() => dismiss(id), durationMs);
  return id;
}

export function useToast() {
  return {
    toasts: readonly(toasts),
    error: (message: string) => push('error', message),
    success: (message: string) => push('success', message),
    dismiss,
  };
}
